export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left image */}
          <div className="flex-shrink-0 w-full max-w-sm lg:max-w-md">
            <div className="rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20home%20entertainment%20setup%20with%20large%20screen%20displaying%20cinematic%20content%2C%20cozy%20living%20room%20atmosphere%2C%20warm%20ambient%20lighting%2C%20comfortable%20sofa%2C%20popcorn%20bowl%2C%20evening%20mood%2C%20clean%20Scandinavian%20interior%20design%2C%20soft%20textures%2C%20inviting%20home%20cinema%20experience&width=800&height=600&seq=about-cinema-platform&orientation=landscape"
                alt="黄瓜影院品牌介绍 - 免费高清影视在线观看平台"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right text */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
              关于黄瓜影院
            </h2>
            <div className="space-y-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                <strong>黄瓜影院</strong>诞生于对影视的热爱 —— 我们希望为每一位观众打造一个<strong>免费、高清、无广告干扰</strong>的在线观影空间。无论是最新上线的热播剧集，还是值得回味的经典老片，这里都有属于您的一片天地。
              </p>
              <p>
                我们持续追踪全网<strong>最新剧集完整版</strong>资源，确保<strong>高清在线观看</strong>画质与<strong>不缓冲流畅播放</strong>的速度体验。从<strong>电影大全</strong>到<strong>电视剧全集</strong>，从热门综艺到纪录片，黄瓜影院的<strong>智能推荐</strong>引擎会根据您的喜好，帮您<strong>快速找片</strong>，告别剧荒。
              </p>
              <p>
                每天有数十万剧迷在黄瓜影院找到心仪的影视内容。我们坚信，好的影视作品值得被更多人看到，好的观影体验不需要付费门槛。
              </p>
            </div>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-sm text-foreground-500">每日更新 80+ 部</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-sm text-foreground-500">12万+ 片库资源</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-sm text-foreground-500">1080P 超清画质</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}